import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DataPermissionsGroup } from 'src/app/demo/interfaces/models-data.interface';
import { CrudService } from 'src/app/demo/service/crud.service';
import { AuthService } from 'src/app/demo/service/auth.service';
import { TreeNode } from 'primeng/api';
import { TreeNodeSelectEvent } from 'primeng/tree';
import { StorageService } from 'src/app/utils/storage.service';

@Component({
  selector: 'app-buttons-group-dependecy',
  templateUrl: './buttons-group-dependecy.component.html',
  styleUrl: './buttons-group-dependecy.component.scss'
})
export class ButtonsGroupDependecyComponent implements OnInit {
  treeGlobalConfig: TreeNode[] = [];
  selectedNodes: TreeNode[] | null = null;
  @Input() selectionMode: string = 'single';
  @Input() showBtnOk: boolean = false;
  @Output() onDependenceSelected: EventEmitter<number | any[]> = new EventEmitter<number | any[]>();

  @Input()
  set resetField(value: boolean) {
    if (value)
      this.cleanField()
  }

  constructor(
    private crudService: CrudService,
    private authService: AuthService,
    private storage: StorageService,
  ) { }

  ngOnInit(): void {
    this.getDataFromHttpOrCacheProfile();
  }

  /**
    * @author Ministerio de cultura
    * Método para obtener datos del perfil desde el localStorage o realizar una consulta HTTP si no están en caché.
    * @createdate 2025-03-27
  */
  getDataFromHttpOrCacheProfile(): void {
    const starageKey: string = 'permisosGrupos';
    const storageType = 'local';
    const $storage  = this.storage.get<DataPermissionsGroup>(starageKey, storageType);
    if ($storage) {
      this.processGroupPermissionsData($storage);
    } else {
     const user = this.authService.decodeTokenUser();

      this.crudService.getDataWithoutPagination({ url: `permisos_grupos/show/${user.id_persona}`, filterForm: { formatear: 1 } }).subscribe({
        next: (res: DataPermissionsGroup) => {
          this.storage.set(starageKey, res, storageType);
          this.processGroupPermissionsData(res);
        },
        error: (err) => console.error(`Error al obtener '${starageKey}' desde el servicio:`, err),
      });
    }
  }

  /**
   * @author Ministerio de cultura
   * Procesa y ajusta los datos de Permisos Grupos
   * @createdate 2025-03-27
   * @param res - Datos de Permisos Grupos obtenidos del servicio o del localStorage.
   */
  processGroupPermissionsData(res: DataPermissionsGroup | string) {
    if(res && typeof res !== 'string')
      this.treeGlobalConfig = this.createTreeNodeToGroupAndDependence(res);
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2024-12-08
    * Metodo que emite la dependencia seleccionada al componente padre.
    * @param $event Evento emitido por el campo de formulario.  
  */
  onNodeSelected($event: TreeNodeSelectEvent): void {
    if (this.selectionMode === 'single' && $event.node.children.length === 0) this.onDependenceSelected.emit($event.node.data.id);
    if (this.selectionMode === 'multiple' && $event.node.children.length === 0) this.onDependenceSelected.emit(this.selectedNodes);
  }
  /**
    * @author Ministerio de cultura
    * @createdate 2024-12-08
    * Metodo que construye el arbol para el campo de formulario.
    * @param data Respuesta del servidor a construir.  
  */
  createTreeNodeToGroupAndDependence(data: DataPermissionsGroup): TreeNode[] {
    return data.formatear.map(group => {
      const filterChildren = group.hijos.filter(item => item.checked === true);
      const node: TreeNode = {
        label: group.padre,
        data: group,
        children: filterChildren.map(child => ({
          label: child.nombre,
          data: child,
          children: []
        }))
      };
      return node.children.length > 0 ? node : null;
    }).filter(item => item !== null);
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2025-03-25
    * Metodo que cierra el modal cuando se ha seleccionado los campos
  */
  closeTreeSelect(treeSelect: any) {
    treeSelect.overlayVisible = false;
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2025-03-25
    * Metodo que limpia el campo
  */
  cleanField() {
    this.selectedNodes = [];
  }
}